import React, { useState } from 'react'
import { CollapsibleHeader, FormGrid, FormGroup, Label, Title, Input } from '../../style'

const PricesSection: React.FC = () => {
  return(
    <>
      <CollapsibleHeader>
        <Title>Preço</Title>
      </CollapsibleHeader>
        <FormGrid style={{ marginTop: '16px' }}>
          <FormGroup>
            <Label>R$/kg min.</Label>
            <Input 
              type='text'
            />
          </FormGroup>
          <FormGroup>
            <Label>R$/kg final</Label>
            <Input 
              type='text'
            />
          </FormGroup>
          <FormGroup>
            <Label>Preço unitário</Label>
            <Input 
              type='text'
            />
          </FormGroup>
          <FormGroup>
            <Label>Desconto (%)</Label>
            <Input 
              type='text'
            />
          </FormGroup>
          <FormGroup>
            <Label>Total do pedido</Label>
            <Input 
              type='text'
            />
          </FormGroup>
        </FormGrid>
    </>
  )
}

export default PricesSection